export enum EmailTemplateEventType {
  COMMENT_ADDED = 'comment-added',
  COMMENT_THREAD_REPLIED_CLIENT = 'comment-thread-replied-client',
  COMMENT_THREAD_REPLIED_USER = 'comment-thread-replied-user',
  DEAL_WON = 'deal-won',
  DOCUMENT_NOT_VIEWED = 'document-not-viewed',
  DOCUMENT_SHARE = 'document-share',
  DOCUMENT_SIGNED = 'document-signed',
  DOCUMENT_VIEWED_ANONYMOUS_USER = 'document-viewed-anonymous-user',
  DOCUMENT_VIEWED_IDENTIFIED_USER = 'document-viewed-identified-user',
  EXPIRE_DOC = 'expire-doc',
}

export const EMAIL_TEMPLATE_VERSION_SEGMENT = { DEFAULT: 'default', VERSION: 'version' } as const;
export const EMAIL_TEMPLATE_SCOPE = { PROPOSIFY: 'proposify', ACCOUNT: 'account' } as const;
export type EmailTemplateScope = (typeof EMAIL_TEMPLATE_SCOPE)[keyof typeof EMAIL_TEMPLATE_SCOPE];
export type EmailTemplateVersionSegment = (typeof EMAIL_TEMPLATE_VERSION_SEGMENT)[keyof typeof EMAIL_TEMPLATE_VERSION_SEGMENT];

export interface EmailTemplatesQueryParamsRequest {
  scope: EmailTemplateScope;
  eventType?: EmailTemplateEventType;
  versionSegment?: string;
  limit?: number;
  nextToken?: string;
}

export interface DeleteEmailTemplateRequest {
  eventType: EmailTemplateEventType;
  versionSegment: string;
}

export interface EmailTemplateListResponse {
  items: EmailTemplateApiResponse[];
  nextToken?: string;
}

export interface EmailTemplateApiResponse {
  id?: string;
  createdBy: string;
  eventType: EmailTemplateEventType;
  html: string;
  name: string;
  options?: Record<string, unknown>;
  subject: string;
  text?: string;
  updatedAt?: string;
  versionSegment: string;
}

export type EmailTemplate = EmailTemplateApiResponse & { scope: EmailTemplateScope };
export type UpsertEmailTemplateRequest = Omit<EmailTemplateApiResponse, 'createdBy' | 'updatedAt'>;
